// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1InvoiceRuleSchema } from './v1/invoiceRuleSchema';
import { v1InvoiceRulesUpdateSchema } from './v1/invoiceRules/updateSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';

export const updateInvoiceRulesPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
});

export const updateInvoiceRulesHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Invoice rules updated
 */
export const updateInvoiceRules200Schema = z.lazy(() => v1InvoiceRuleSchema);

/**
 * @description Unauthorized
 */
export const updateInvoiceRules401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Validation errors
 */
export const updateInvoiceRules422Schema = z.lazy(() => v1ValidationErrorSchema);

export const updateInvoiceRulesMutationRequestSchema = z.lazy(() => v1InvoiceRulesUpdateSchema);

export const updateInvoiceRulesMutationResponseSchema = z.lazy(() => updateInvoiceRules200Schema);
